/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command for searching global notifications with pagination (infinite scroll)
 * @export
 * @interface SearchNotificationsCommand
 */
export interface SearchNotificationsCommand {
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof SearchNotificationsCommand
     */
    pageNumber?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof SearchNotificationsCommand
     */
    pageSize?: number;
    /**
     * Filtre sur le code de categorie (cf. NotificationDto.category). Une categorie INCONNUE est ignoree par le serveur (liste non filtree) plutot que de renvoyer un resultat vide inexplicable.
     * 
     * @type {string}
     * @memberof SearchNotificationsCommand
     */
    category?: string | null;
    /**
     * Ne renvoyer que les notifications non lues (isRead = false)
     * @type {boolean}
     * @memberof SearchNotificationsCommand
     */
    onlyUnread?: boolean | null;
}

/**
 * Check if a given object implements the SearchNotificationsCommand interface.
 */
export function instanceOfSearchNotificationsCommand(value: object): value is SearchNotificationsCommand {
    return true;
}

export function SearchNotificationsCommandFromJSON(json: any): SearchNotificationsCommand {
    return SearchNotificationsCommandFromJSONTyped(json, false);
}

export function SearchNotificationsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchNotificationsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'category': json['category'] == null ? undefined : json['category'],
        'onlyUnread': json['onlyUnread'] == null ? undefined : json['onlyUnread'],
    };
}

export function SearchNotificationsCommandToJSON(json: any): SearchNotificationsCommand {
    return SearchNotificationsCommandToJSONTyped(json, false);
}

export function SearchNotificationsCommandToJSONTyped(value?: SearchNotificationsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'category': value['category'],
        'onlyUnread': value['onlyUnread'],
    };
}

